<template>
  <div>
    <div class="link-warp">
      <div class="link-item active">资金明细</div>
    </div>
    <div class="main">
      <div class="condition-section">
        <div class="con-row">
          <div  style="margin: 0 20px">交易类型：</div>
          <div
            :class="[
              'item',
              { active: item.value === searchObj.jylx },
            ]"
            v-for="item in transDetailTypeList"
            :key="item.value"
            @click="onCheckTransDetailType(item.value)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="cond-row">
          <div class="item">
            <Input
              class="height45"
              v-model="searchObj.keywords"
              placeholder="请输入搜索的关键词"
              style="width: 300px"
              clearable
            />
          </div>
          <div class="item" style="margin-right: 60px">
            <div style="margin-right: 10px">交易时间：</div>
            <DatePicker
              class="height45"
              v-model="searchObj.startAtStr"
              @on-change="handleChange"
              type="daterange"
              placeholder="请输入交易时间"
              style="width: 200px"
              clearable
            ></DatePicker>
          </div>
          <div class="item">
            <Button
              class="btn-height45"
              type="primary"
              style="margin-right: 20px"
              @click="onSearch"
              >搜索</Button
            >
            <Button class="btn-height45" @click="onSearchCancel">重置</Button>
          </div>
        </div>
      </div>
      <div class="table-data">
        <div class="total">搜索结果（{{ searchObj.total }}）</div>
        <Table
          class="domain-table"
          :columns="columns"
          :data="data"
          :loading="tableLoading"
        >
          <template slot="jylx" slot-scope="{ row }">
            <div>
              {{ row.jylx | status }}
            </div>
          </template>
          <template slot="remarks" slot-scope="{ row }">
            <Button @click="onShowRemark(row.remarks)">查看备注</Button>
          </template>
        </Table>
        <div class="page-tool">
          <Page
            :current="searchObj.page"
            :total="searchObj.total"
            :page-size="searchObj.limit"
            @on-change="onPageChange"
          />
        </div>
      </div>
    </div>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remarks"
    ></pushRemarkModal>
  </div>
</template>

<script>
import pushRemarkModal from "components/push/pushRemarkModal.vue";
import { financeList, financeTypeList } from "api/customer.js";
export default {
  name: "transferoutRecord",
  components: {
    pushRemarkModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "支出";
          break;
        case 1:
          title = "收入";
          break;
        case 2:
          title = "冻结";
          break;
        case 3:
          title = "解冻";
          break;
      }
      return title;
    },
    financeTypeStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "支出";
          break;
        case 1:
          title = "收入";
          break;
        case 2:
          title = "冻结";
          break;
        case 3:
          title = "解冻";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      // 交易状态
      transDetailTypeList: [
        {
          name: "全部",
          value: -1,
        },
        {
          name: "支出",
          value: 0,
        },
        {
          name: "收入",
          value: 1,
        },
        {
          name: "冻结",
          value: 2,
        },
        {
          name: "解冻",
          value: 3,
        },
      ],
      searchObj: {
        jylx: -1,
        keywords: "",
        startAtStr:  [],
        endAt: "",
        startAt: "",
        cwlx: -1,
        page: 1,
        limit: 20,
        total: 0,
      },
      columns: [
        {
          title: "交易日期",
          align: "center",
          key: "createdTime",
        },
        {
          title: "类型",
          align: "center",
          slot: "jylx",
        },
        {
          title: "交易金额",
          align: "center",
          key: "amount",
        },
        {
          title: "历史余额",
          align: "center",
          key: "hisAmount",
        },
        {
          title: "查看备注",
          align: "center",
          slot: "remarks",
        },
      ],
      data: [],
      tableLoading: false,
      financeTypeData: [], // 财务类型
      tempFinanceTypeData: [],
      pushRemarkModalVisibility: false,
      remarks: "", // 备注内容
    };
  },
  created() {
    this.req_getFinanceTypeList();
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          gjc: this.searchObj.keywords,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          endTime: this.searchObj.endAt,
          createdTime: this.searchObj.startAt,
        };
        this.searchObj.jylx !== -1 &&
          (params.state = this.searchObj.jylx);
        this.tableLoading = true;
        const { code, data } = await financeList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 切换状态
    onCheckTransDetailType(val) {
      this.searchObj.jylx = val;
      if (val > 0) {
        this.financeTypeData = this.tempFinanceTypeData.filter((o) => {
          return o.t === val - 1;
        });
      }
      this.onPageChange(1);
    },
    // 获取财务类型
    async req_getFinanceTypeList() {
      try {
        this.loading = true;
        const { code, data, result } = await financeTypeList();
        this.loading = false;
        if (code === 200 && result) {
          this.financeTypeData = data;
          this.tempFinanceTypeData = data;
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 时间变化
    handleChange(event) {
      //this.searchObj.startAtStr = val;
	  this.searchObj.startAt = event[0];
	  this.searchObj.endAt = event[1];
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remarks = val;
    },
  },
};
</script>
<style lang="less" scoped>
.link-warp {
  padding: 0 15px;
  margin-top: 20px;
  .link-item {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 30px;
    font-size: 16px;
    font-weight: 600;
    color: #4F5867;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    // &::before {
    //   content: "";
    //   position: absolute;
    //   bottom: -1px;
    //   width: 0;
    //   height: 2px;
    //   background-color: transparent;
    //   transition: all 0.3s;
    // }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    border: 1px solid #759DE6;
    // &::before {
    //   width: 100%;
    //   background-color: #3992e9;
    // }
  }
}
.condition-section {
  margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .con-row {
    display: flex;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    .item {
      font-size: 14px;
      font-weight: 600;
      color: #434063;
      cursor: pointer;
      margin-right: 40px;
      background: #f5f9fe;
      border-radius: 54px;
      border: 1px solid #759de6;
      width: 100px;
      text-align: center;
      line-height: 40px;
    }
    .item.active {
      color: #FFF;
      background: #315491;
    }
  }
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
.main {
  margin: 20px 15px;
  padding: 20px;
    background: #fff;
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
